import { BrowserVault, IdentityVaultConfig, Vault, VaultType } from '@ionic-enterprise/identity-vault'
import key from './key'
import Logger from './logger.service'
import { isPlatformNative } from '../utilities'

export class KeyVaultService {
  private vault!: Vault | BrowserVault

  private initializing: Promise<void> | undefined

  async initialize(): Promise<void> {
    if (!this.initializing) {
      // eslint-disable-next-line no-async-promise-executor
      this.initializing = new Promise(async (resolve, reject) => {
        try {
          const config: IdentityVaultConfig = {
            key: 'io.zoll.now.keys',
            type: VaultType.SecureStorage,
          }

          if (isPlatformNative()) {
            this.vault = new Vault()
            this.vault.onError((err) => {
              Logger.errorObj(`KeyVaultService: onError callback - error: ${JSON.stringify(err)}`, err)
            })
          } else {
            this.vault = new BrowserVault()
          }

          await this.vault.initialize(config)
          resolve()
        } catch (err) {
          Logger.error(`Error initializing Identity Vault: ${err}`)
          Logger.log(Logger.LINE)
          reject(err)
        }
      })
    }

    return this.initializing
  }

  async get(encryptionKey: string): Promise<string> {
    await this.initialize()

    Logger.info(`KeyVaultService: Attempting to get a value from the vault for key: ${encryptionKey}`)

    let dbKey = await this.vault.getValue(encryptionKey)
    Logger.info(`KeyVaultService: After await this.vault.getValue(${encryptionKey})`)

    if (!dbKey) {
      dbKey = key.get()
      Logger.info('KeyVaultService: After await key.get()')

      await this.set(encryptionKey, dbKey)
      Logger.info(`KeyVaultService: After await this.set(${encryptionKey}, dbKey)`)
    } else {
      Logger.info(`KeyVaultService: Already had value in the vault for key: ${encryptionKey}`)
    }

    return dbKey
  }

  async clear(): Promise<void> {
    await this.initialize()

    return this.vault.clear()
  }

  private async set(encryptionKey: string, value: string): Promise<void> {
    await this.initialize()

    return this.vault.setValue(encryptionKey, value)
  }
}

export default new KeyVaultService()
